<template>

    <templatesite>

        <template v-slot:appheader>  <appheader></appheader>  </template>
        <template v-slot:appsidebar>  <appsidebar></appsidebar> </template>
        <template v-slot:appcontent>

            <template v-if="pagefacturationcaisse!==5 && pagefacturationcaisse!==3">

                <appmenu ref="appmenu" :accesviewrapporteditioncaisse="accesviewrapporteditioncaisse"
                :accesviewutilitairecaisse="accesviewutilitairecaisse"></appmenu>


                <div class="content cxe-page" style="margin-top: 0">

                    <!-- En-tête : nom, état, type, journée, alerte date antérieure -->
                    <div class="ds-page-head cxe-head">
                        <div class="cxe-head__title">
                            <span class="cxe-head__icon"><i class="ri-safe-2-line"></i></span>
                            <div>
                                <h1 class="cxe-head__h1">{{$store.state.intitulecaisse}}</h1>
                                <div class="cxe-head__sub">
                                    <span v-if="$store.state.ouverturedelacaisse!==0" class="cxe-pill cxe-pill--ok">Ouverte</span>
                                    <span v-else class="cxe-pill cxe-pill--off">Fermée</span>
                                    <span class="cxe-pill cxe-pill--type">{{ $store.state.typc===1 ? 'Caisse principale' : 'Caisse auxiliaire' }}</span>
                                    <span v-if="$store.state.dateouverturecaisse"><i class="ri-calendar-line"></i> Journée du <b class="cxe-num cxe-ink">{{$store.state.dateouverturecaisse}}</b></span>

                                    <!-- Badge permanent : rappelle, tant que la caisse est ouverte sur
                                         une journée antérieure, que la date de saisie n'est pas celle
                                         du jour. Cliquable pour rouvrir le message complet. -->
                                    <span v-if="alertedatecaisse"
                                          @click="showalertedatecaisse=true"
                                          title="Cliquez pour revoir le détail"
                                          class="alertedatecaisse-badge cxe-glow inline-flex items-center">
                                        <i class="ri-error-warning-fill me-1 align-middle" style="font-size: 15px;"></i>
                                        Journée du {{alertedatecaisse.datejourne}} non clôturée
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="cxe-head__actions">
                            <button @click="init" type="button" class="ds-btn-ghost cxe-btn"><i class="ri-refresh-line"></i>Actualiser</button>
                        </div>
                    </div>


                    <!-- =================== Caisse ouverte =================== -->
                    <template v-if="$store.state.ouverturedelacaisse!==0">

                        <!-- Bandeau : solde (ticket), recettes, dépenses, facturation -->
                        <section class="cxe-hero" :class="{ 'cxe-hero--nosolde': !accesviewsoldecaisse }">

                            <template v-if="accesviewsoldecaisse">
                                <div class="cxe-ticket">
                                    <div class="cxe-ticket__lab">
                                        <span><i class="ri-money-cny-box-line"></i> Solde en caisse</span>
                                        <button type="button" class="cxe-ticket__eye" :title="masquermontants ? 'Afficher les montants' : 'Masquer les montants'" @click="basculermasquermontants">
                                            <i :class="masquermontants ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                                        </button>
                                    </div>
                                    <div class="cxe-ticket__amt">{{ montantaffiche($store.state.montantencaisse) }}<small>FCFA</small></div>
                                    <div class="cxe-ticket__meta">
                                        <span>Flux net <b :style="{ color: fluxnet>=0 ? '#6ee7b7' : '#fca5a5' }">{{ fluxnet>=0 ? '+' : '' }}{{ montantaffiche(fluxnet) }}</b></span>
                                    </div>
                                    <div class="cxe-ticket__flux" title="Part des recettes et des dépenses">
                                        <span :style="{ width: partrecettes + '%' }"></span><span :style="{ width: (100-partrecettes) + '%' }"></span>
                                    </div>
                                </div>

                                <div class="cxe-kpi cxe-kpi--in">
                                    <div class="cxe-kpi__top"><span class="cxe-kpi__lab">Total des recettes</span><span class="cxe-kpi__ic"><i class="ri-arrow-down-line"></i></span></div>
                                    <div class="cxe-kpi__v">{{ montantaffiche($store.state.totalrecette) }}<small>FCFA</small></div>
                                    <svg v-if="sparkrecettes" class="cxe-spark" viewBox="0 0 200 30" preserveAspectRatio="none">
                                        <path :d="sparkrecettes + ' L200,30 L0,30Z'" fill="rgb(38 191 148)" opacity=".1"/>
                                        <path :d="sparkrecettes" fill="none" stroke="rgb(38 191 148)" stroke-width="1.6" vector-effect="non-scaling-stroke"/>
                                    </svg>
                                    <div class="cxe-kpi__foot">Tendance du mois en cours</div>
                                </div>

                                <div class="cxe-kpi cxe-kpi--out">
                                    <div class="cxe-kpi__top"><span class="cxe-kpi__lab">Total des dépenses</span><span class="cxe-kpi__ic"><i class="ri-arrow-up-line"></i></span></div>
                                    <div class="cxe-kpi__v">{{ montantaffiche($store.state.totaldepense) }}<small>FCFA</small></div>
                                    <svg v-if="sparkdepenses" class="cxe-spark" viewBox="0 0 200 30" preserveAspectRatio="none">
                                        <path :d="sparkdepenses + ' L200,30 L0,30Z'" fill="rgb(230 83 60)" opacity=".1"/>
                                        <path :d="sparkdepenses" fill="none" stroke="rgb(230 83 60)" stroke-width="1.6" vector-effect="non-scaling-stroke"/>
                                    </svg>
                                    <div class="cxe-kpi__foot">soit {{ partdepenses }} % des recettes</div>
                                </div>
                            </template>

                            <button v-if="accesfacturation" type="button" class="cxe-cta" @click="btnfacturation">
                                <kbd>F2</kbd>
                                <span class="cxe-cta__ic"><i class="ri-shopping-cart-2-line"></i></span>
                                <div><h3>Facturation</h3><p>Nouvelle vente au comptoir</p></div>
                            </button>
                        </section>


                        <!-- Opérations de caisse, regroupées par nature -->
                        <div class="cxe-ops-head">
                            <h2>Opérations de caisse<span>{{ nboperationsdisponibles }} disponibles</span></h2>
                            <label class="cxe-search">
                                <i class="ri-search-line"></i>
                                <input ref="rechercheoperation" v-model="rechercheoperation" placeholder="Rechercher une opération..." @keydown.esc="rechercheoperation=''">
                                <kbd>/</kbd>
                            </label>
                        </div>

                        <section class="cxe-groups">
                            <div v-for="groupe in groupesoperations" :key="groupe.code" class="cxe-grp" :class="'cxe-g-' + groupe.code">
                                <div class="cxe-grp__h">
                                    <span class="cxe-grp__dot"><i :class="groupe.icone"></i></span>
                                    <b>{{ groupe.titre }}</b>
                                    <span class="cxe-grp__n">{{ groupe.items.length }}</span>
                                </div>
                                <button v-for="(op, index) in groupe.items" :key="index" type="button"
                                        class="cxe-op" :class="{ 'cxe-op--soon': op.bientot }"
                                        :disabled="op.bientot" @click="op.action && op.action()">
                                    <span class="cxe-op__i"><i :class="op.icone"></i></span>
                                    <span class="cxe-op__t"><b>{{ op.titre }}</b><span>{{ op.detail }}</span></span>
                                    <span v-if="op.bientot" class="cxe-soon">Bientôt</span>
                                    <i v-else class="ri-arrow-right-s-line cxe-op__go"></i>
                                </button>
                            </div>
                            <div v-if="groupesoperations.length===0" class="cxe-empty">
                                <i class="ri-search-eye-line"></i>
                                Aucune opération ne correspond à « {{ rechercheoperation }} »
                            </div>
                        </section>


                        <!-- Analyse : recettes / dépenses du mois + top 10 -->
                        <section class="cxe-ana">
                            <div class="cxe-card">
                                <div class="cxe-card__h">
                                    <h3><i class="ri-bar-chart-2-line"></i>Recettes et dépenses du mois</h3>
                                </div>
                                <div class="cxe-card__b">
                                    <apexcharts type="bar" height="350" :options="chartoptionscaisse" :series="series4"></apexcharts>
                                </div>
                            </div>

                            <div class="cxe-card">
                                <div class="cxe-card__h">
                                    <h3><i class="ri-trophy-line"></i>Top 10 des articles vendus<span v-if="top10courant" class="cxe-card__sub">{{ top10courant.moisencours }}</span></h3>
                                    <div v-if="allgraphs.length>1" class="cxe-tabs">
                                        <button v-for="(graph,index) of allgraphs" :key="index" type="button"
                                                :class="{ on: indextop10===index }" @click="indextop10=index">
                                            {{ (graph.chartOptions && graph.chartOptions.title && graph.chartOptions.title.text) || ('Liste ' + (index+1)) }}
                                        </button>
                                    </div>
                                </div>
                                <div class="cxe-card__b">
                                    <ol v-if="top10lignes.length" class="cxe-top10">
                                        <li v-for="(ligne,index) in top10lignes" :key="index">
                                            <span class="cxe-top10__rk">{{ String(index+1).padStart(2,'0') }}</span>
                                            <div>
                                                <div class="cxe-top10__lib">{{ ligne.libelle }}</div>
                                                <div class="cxe-top10__bar"><span :style="{ width: ligne.pct + '%' }"></span></div>
                                            </div>
                                            <div class="cxe-top10__q">{{ formatNumber(ligne.montant) }}<small>FCFA</small></div>
                                        </li>
                                    </ol>
                                    <div v-else class="cxe-empty cxe-empty--flat"><i class="ri-inbox-line"></i>Aucune vente ce mois-ci</div>
                                </div>
                            </div>
                        </section>


                        <!-- Articles disponibles à la caisse -->
                        <div v-if="accestableauxdestock" class="cxe-card">
                            <div class="cxe-card__h">
                                <h3><i class="ri-archive-stack-line"></i>Articles disponibles à la caisse</h3>
                                <div class="cxe-card__tools">
                                    <div class="cxe-chips">
                                        <button type="button" class="cxe-chip" :class="{ on: filtrestock==='tous' }" @click="filtrestock='tous'">Tous<b>{{ comptesstock.tous }}</b></button>
                                        <button type="button" class="cxe-chip" :class="{ on: filtrestock==='faible' }" @click="filtrestock='faible'">Stock faible<b>{{ comptesstock.faible }}</b></button>
                                        <button type="button" class="cxe-chip" :class="{ on: filtrestock==='rupture' }" @click="filtrestock='rupture'">Rupture<b>{{ comptesstock.rupture }}</b></button>
                                    </div>
                                    <label class="cxe-search cxe-search--sm">
                                        <i class="ri-search-line"></i>
                                        <input v-model="searchwordallprod" placeholder="Article...">
                                    </label>
                                    <button @click="loadtrt" type="button" class="ds-btn-ghost cxe-btn" title="Réinitialiser le contenu de la table"><i class="ri-refresh-line"></i></button>
                                </div>
                            </div>
                            <div class="cxe-tbl-wrap">
                                <table class="cxe-table">
                                    <thead>
                                    <tr>
                                        <th class="th cxe-th-sort" :class="{ on: tristock.cle==='libelle' }" @click="triercolonne('libelle')">Article <i :class="icone_tri('libelle')"></i></th>
                                        <th class="th th--r cxe-th-sort" :class="{ on: tristock.cle==='rstck' }" @click="triercolonne('rstck')">Stock <i :class="icone_tri('rstck')"></i></th>
                                        <th class="th th--r cxe-th-sort" :class="{ on: tristock.cle==='pu' }" @click="triercolonne('pu')">Prix de vente <i :class="icone_tri('pu')"></i></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="articlescaisse.length">
                                        <tr v-for="(datavalue,index) in articlescaisse" :key="index">
                                            <td class="td cxe-strong" data-label="Article  : ">{{ datavalue.libelle }}</td>
                                            <td class="td td--r" data-label="Stock  : ">
                                                <span class="cxe-st" :class="'cxe-st--' + niveaustock(datavalue.rstck)">
                                                    <i v-if="niveaustock(datavalue.rstck)==='ko'" class="ri-close-circle-fill"></i>{{ datavalue.rstck }}
                                                </span>
                                            </td>
                                            <td class="td td--r cxe-num" data-label="Prix de vente  : ">{{ formatNumber(datavalue.pu) }}</td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td colspan="3" class="td cxe-empty cxe-empty--flat"><i class="ri-inbox-line"></i>Aucun article trouvé</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="cxe-tbl-foot"><span>{{ articlescaisse.length }} article(s)</span><span>Stock du magasin rattaché à la caisse</span></div>
                        </div>

                    </template>


                    <!-- =================== Caisse fermée =================== -->
                    <section v-else class="cxe-closed">
                        <div class="cxe-closed__hero">
                            <span class="cxe-closed__ic"><i class="ri-lock-2-line"></i></span>
                            <h2>La caisse est fermée</h2>
                            <p>Ouvrez la caisse pour facturer et enregistrer des opérations. Les états de la dernière journée restent consultables.</p>
                            <button type="button" class="ti-btn ti-btn-primary-full cxe-btn-open" @click="ouvrircaissedepuismenu"><i class="ri-safe-2-line"></i> Ouvrir la caisse</button>
                        </div>
                        <div class="cxe-grp cxe-g-ctrl">
                            <div class="cxe-grp__h">
                                <span class="cxe-grp__dot"><i class="ri-clipboard-line"></i></span>
                                <b>États disponibles</b>
                                <span class="cxe-grp__n">{{ $store.state.typc===1 ? 2 : 1 }}</span>
                            </div>
                            <button v-if="$store.state.typc===1" type="button" class="cxe-op" @click="btnmodaletatdespaiement('all')">
                                <span class="cxe-op__i"><i class="ri-coins-line"></i></span>
                                <span class="cxe-op__t"><b>État de paiement et billetage</b><span>État de paiement de la caisse</span></span>
                                <i class="ri-arrow-right-s-line cxe-op__go"></i>
                            </button>
                            <button v-else type="button" class="cxe-op" @click="btnmodaletatdespaiement('unique')">
                                <span class="cxe-op__i"><i class="ri-coins-line"></i></span>
                                <span class="cxe-op__t"><b>État de paiement et billetage</b><span>État de paiement de la caisse</span></span>
                                <i class="ri-arrow-right-s-line cxe-op__go"></i>
                            </button>
                            <button v-if="$store.state.typc===1" type="button" class="cxe-op" @click="btnmodaletatdespaiement('global')">
                                <span class="cxe-op__i"><i class="ri-stack-line"></i></span>
                                <span class="cxe-op__t"><b>État global des caisses fermées</b><span>Toutes les caisses clôturées</span></span>
                                <i class="ri-arrow-right-s-line cxe-op__go"></i>
                            </button>
                        </div>
                    </section>

                </div>

            </template>
            <template v-else>

                <template  v-if="$store.state.ouverturedelacaisse===0">

                    <appmenu5 ></appmenu5>


                </template>

                <div class="content" >
                    <div class="main-content">


                        <template  v-if="$store.state.ouverturedelacaisse!==0">


                            <facturation5page v-if="accesfacturation && pagefacturationcaisse===5"></facturation5page>
                            <facturation3page v-if="accesfacturation && pagefacturationcaisse===3"></facturation3page>


                        </template>







                    </div>
                </div>

            </template>


        </template>

    </templatesite>

    <facturation2 ref="facturation2" @closed="closemodalfacturation"></facturation2>
    <facturation1 ref="facturation1" @closed="closemodalfacturation"></facturation1>
    <facturation5 ref="facturation5" @closed="closemodalfacturation"></facturation5>
    <facturation6  :accesviewrapporteditioncaisse="accesviewrapporteditioncaisse"  ref="facturation6" @closed="(v) => onClosedPos6('ancienne', v)"></facturation6>
    <!-- Caisse type 6, nouvelle version (file des scans). Par défaut ; le choix
         ancienne / nouvelle est gardé par poste (localStorage pos6_version_v1). -->
    <facturation6new :accesviewrapporteditioncaisse="accesviewrapporteditioncaisse" ref="facturation6new"
                     @closed="(v) => onClosedPos6('nouvelle', v)" @changerversion="changerVersionPos6"></facturation6new>
    <!-- Ancienne version ouverte : bouton flottant pour repasser à la nouvelle
         (form_index6.vue n'est pas modifié, le bouton vit donc ici). -->
    <button v-if="pos6AncienneOuverte" type="button" class="pos6-retour-nouvelle"
            @click="changerVersionPos6('nouvelle')" title="Passer à la nouvelle version de la caisse">
        <i class="ri-refresh-line"></i> Nouvelle version
    </button>
    <moadalindexavance ref="moadalindexavance" @closed="closemodal"></moadalindexavance>
    <modaldepense ref="modaldepense" @closed="closemodal"></modaldepense>
    <moadalindexreglement ref="moadalindexreglement" @closed="closemodal"></moadalindexreglement>
    <moadalindexbcd ref="moadalindexbcd" @closed="closemodal"></moadalindexbcd>
    <moadalindexreglementbcd ref="moadalindexreglementbcd" @closed="closemodal"></moadalindexreglementbcd>
    <moadalindextransfertdefonddecaisse ref="moadalindextransfertdefonddecaisse" @closed="closemodal"></moadalindextransfertdefonddecaisse>
    <moadalvalidationtransaction ref="moadalvalidationtransaction" @closed="closemodal"></moadalvalidationtransaction>
    <modalsoldecaissebanque ref="modalsoldecaissebanque" ></modalsoldecaissebanque>
    <modaletatdespaiement ref="modaletatdespaiement" ></modaletatdespaiement>

    <!-- ---------------------------------------------------------------------
         Alerte « journée de caisse antérieure au jour courant ».

         S'affiche à l'entrée dans la caisse uniquement. L'avertissement est
         déjà consigné en base par le serveur au moment où cette modale
         apparaît ; la fermeture enregistre la prise de connaissance.

         Un seul bouton : croix et bouton déclenchent la même action.
         --------------------------------------------------------------------- -->
    <Transition name="modal-fade">
    <div v-if="showalertedatecaisse && alertedatecaisse" class="cf-overlay" tabindex="-1">
        <Transition name="modal-slide">
            <div v-if="showalertedatecaisse && alertedatecaisse" class="cf-dialog cf-dialog--md alertedatecaisse-content">

                <!-- Bandeau rouge pleine largeur : c'est lui qui doit accrocher l'oeil
                     avant même la lecture du texte. -->
                <div class="alertedatecaisse-bandeau flex items-center justify-between px-4 py-3">

                    <h6 class="mb-0 text-white font-semibold flex items-center text-[0.95rem]">
                        <i class="ri-error-warning-fill me-2 alertedatecaisse-pulse" style="font-size: 24px;"></i>
                        Caisse ouverte à une date antérieure
                    </h6>

                    <button @click="fermeralertedatecaisse" type="button"
                            class="alertedatecaisse-fermer flex items-center justify-center"
                            aria-label="Fermer">
                        <i class="ri-close-line" style="font-size: 20px;"></i>
                    </button>
                </div>

                <div class="cf-dialog-body">

                    <!-- Message principal -->
                    <div class="text-center mb-5">

                        <h5 class="text-danger font-bold mb-1 text-[1.15rem]">
                            La journée du {{alertedatecaisse.datejourne}} n'a pas été clôturée
                        </h5>

                        <p class="mb-0 text-[#8c9097] dark:text-white/50">
                            Nous sommes le <strong class="text-defaulttextcolor dark:text-defaulttextcolor/80">{{alertedatecaisse.dateserveur}}</strong>,
                            soit {{alertedatecaisse.ecart_jours}}
                            jour<template v-if="alertedatecaisse.ecart_jours > 1">s</template> de décalage.
                        </p>
                    </div>

                    <!-- Confrontation des deux dates : la date de saisie en rouge,
                         la date réelle en neutre. -->
                    <div class="grid grid-cols-12 gap-3 items-center mb-5">

                        <div class="xl:col-span-5 col-span-12">
                            <div class="alertedatecaisse-carte alertedatecaisse-carte-danger text-center p-3">
                                <span class="block text-[0.7rem] uppercase tracking-wide text-danger mb-1">Vos saisies seront datées du</span>
                                <span class="block font-bold text-danger text-[1.35rem]">{{alertedatecaisse.datejourne}}</span>
                            </div>
                        </div>

                        <div class="xl:col-span-2 col-span-12 text-center">
                            <i class="ri-arrow-right-line text-[#8c9097] dark:text-white/50 hidden xl:inline" style="font-size: 24px;"></i>
                            <i class="ri-arrow-down-line text-[#8c9097] dark:text-white/50 xl:hidden" style="font-size: 24px;"></i>
                        </div>

                        <div class="xl:col-span-5 col-span-12">
                            <div class="alertedatecaisse-carte text-center p-3">
                                <span class="block text-[0.7rem] uppercase tracking-wide text-[#8c9097] dark:text-white/50 mb-1">Alors que nous sommes le</span>
                                <span class="block font-bold text-[1.35rem]">{{alertedatecaisse.dateserveur}}</span>
                            </div>
                        </div>

                    </div>

                    <!-- Conséquence concrète -->
                    <div class="alertedatecaisse-encart p-3 mb-4">
                        <div class="flex items-start">
                            <i class="ri-alert-fill text-danger me-2" style="font-size: 18px; line-height: 1.4;"></i>
                            <div>
                                <strong class="text-danger block mb-1">Toutes vos ventes partiront dans la journée du {{alertedatecaisse.datejourne}}</strong>
                                <span class="text-[0.8rem]">
                                    La caisse <strong>{{$store.state.intitulecaisse}}</strong> reste ouverte sur cette
                                    journée. Chaque opération enregistrée maintenant y sera rattachée, et non à la
                                    date du jour.
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Marche à suivre -->
                    <div class="mb-4">
                        <span class="block font-semibold mb-2">À faire avant de poursuivre</span>
                        <ol class="ps-5 mb-0 text-[0.85rem]" style="list-style: decimal;">
                            <li class="mb-1">Clôturer la journée du <strong>{{alertedatecaisse.datejourne}}</strong>.</li>
                            <li>Rouvrir la caisse à la date du <strong>{{alertedatecaisse.dateserveur}}</strong>.</li>
                        </ol>
                    </div>

                    <div class="p-3 rounded-[0.35rem] bg-light dark:bg-black/20">
                        <span class="text-[0.75rem] text-[#8c9097] dark:text-white/50">
                            <i class="ri-shield-check-line me-1 align-middle"></i>
                            Cet avertissement est enregistré, ainsi que votre prise de connaissance.
                        </span>
                    </div>

                </div>

                <div class="cf-dialog-foot">
                    <button @click="fermeralertedatecaisse" type="button"
                            class="ti-btn bg-danger text-white btn-wave !font-medium !me-0 !text-[0.85rem] !rounded-[0.35rem] !py-[0.51rem] !px-[1.2rem] shadow-none">
                        <i class="ri-check-line me-1 align-middle"></i>
                        J'ai compris
                    </button>
                </div>

            </div>
        </Transition>
    </div>
    </Transition>

</template>

<script>
    import VueApexCharts from "vue3-apexcharts";
    import modaldepense from "@/components/views/pages/caisse/depense/index";
    import moadalindexreglement from "@/components/views/pages/caisse/reglement/index";
    import moadalindexbcd from "@/components/views/pages/caisse/bcd/index";
    import moadalindexreglementbcd from "@/components/views/pages/caisse/bcd/reglement/index";
    import moadalindextransfertdefonddecaisse from "@/components/views/pages/caisse/transfertdefonddecaisse/index";
    import moadalvalidationtransaction from "@/components/views/pages/caisse/validationtransaction/index";
    import moadalindexavance from "@/components/views/pages/caisse/avance/index";
    import modalsoldecaissebanque from "@/components/views/pages/caisse/rapport/modal_soldecaissebanque";
    //import facturation1 from "@/components/views/pages/caisse/facturation/1/index";
    import facturation1 from "@/components/views/pages/caisse/facturation/1/form_index1.vue";
    //import facturation2 from "@/components/views/pages/caisse/facturation/2/formcaisse2_launcher";
    import facturation2 from "@/components/views/pages/caisse/facturation/2/formcaisse2";
    import facturation5 from "@/components/views/pages/caisse/facturation/5/formcaisse5";
    import facturation6 from "@/components/views/pages/caisse/facturation/6/form_index6.vue";
    import facturation6new from "@/components/views/pages/caisse/facturation/6/form_index6_new.vue";
    import facturation5page from "@/components/views/pages/caisse/facturation/5/form5page";
    import facturation3page from "@/components/views/pages/caisse/facturation/3/form2page";
    // import facturation5page from "@/components/views/pages/caisse/facturation/test/test";
    import modaletatdespaiement from "@/components/views/pages/caisse/rapport/modal_etatdespaiement";





    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/caisse/menu";
    import appmenu5 from "@/components/views/pages/caisse/menu5";
    import * as JwtService from "@/common/jwt.service";
    import {cloneobjet, currencyFormatDE, randomString} from "@/allfunction";
    import {mapGetters} from "vuex";
    const axios =require('axios');




    export default {
        /* eslint-disable */
        name: "ewallet",
        components: {
            templatesite,
            appheader,
            appsidebar,
            appmenu,
            appmenu5,
            facturation1,
            facturation2,
            facturation5,
            facturation6,
            facturation6new,
            facturation3page,
            facturation5page,
            modaldepense,
            moadalindexreglement,
            moadalindexbcd,
            moadalindexreglementbcd,
            moadalindextransfertdefonddecaisse,
            moadalindexavance,
            moadalvalidationtransaction,
            modalsoldecaissebanque,
            modaletatdespaiement,
            apexcharts: VueApexCharts,


        },
        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },


        },

        computed:{
            ...mapGetters(['listedesarticlespourlacaisse']),

            /* ── Tableau de bord de la caisse (refonte 2026-10-25) ── */

            fluxnet(){
                return Number(this.$store.state.totalrecette||0) - Number(this.$store.state.totaldepense||0);
            },

            partrecettes(){
                const r=Number(this.$store.state.totalrecette||0), d=Number(this.$store.state.totaldepense||0);
                return (r+d)>0 ? Math.round(r/(r+d)*100) : 50;
            },

            partdepenses(){
                const r=Number(this.$store.state.totalrecette||0), d=Number(this.$store.state.totaldepense||0);
                return r>0 ? (d/r*100).toFixed(1).replace('.',',') : '0';
            },

            sparkrecettes(){ return this.tracersparkline('RECETTES'); },
            sparkdepenses(){ return this.tracersparkline('DEPENSE'); },

            /* Une entrée par carte de l'ancien écran, avec sa condition d'affichage d'origine. */
            operationscaisse(){
                const P=this.$store.state.typc===1, A=this.$store.state.typc===0, typc=this.$store.state.typc;
                const ops=[
                    {g:'in',  titre:'Règlement client',            detail:'Encaisser une facture client',     icone:'ri-hand-coin-line',       ok:this.accesreglementclt,       action:()=>this.btnmoadalindexreglement('CLT')},
                    {g:'in',  titre:'Avance client',               detail:"Acompte reçu d'un client",         icone:'ri-user-received-2-line', ok:this.accessavanceclient,      action:()=>this.btnmoadalindexavance('CLT')},
                    {g:'in',  titre:'Dépôt en compte client',      detail:'Crédit sur le compte du client',   icone:'ri-wallet-3-line',        ok:this.accesdepotencompteclt,   action:()=>this.btnmodaldepense('DPCC')},
                    {g:'in',  titre:'Règlement BCD interne',       detail:'BCD interne à la caisse',          icone:'ri-file-list-3-line',     ok:this.accesreglementbcd,       action:()=>this.btnmoadalindexreglementbcd()},
                    {g:'out', titre:'Dépense',                     detail:'Sortie de caisse justifiée',       icone:'ri-calculator-line',      ok:this.accesdepense,            action:()=>this.btnmodaldepense('DEP')},
                    {g:'out', titre:'Règlement fournisseur',       detail:'Payer une facture fournisseur',    icone:'ri-truck-line',           ok:this.accesreglementfrs,       action:()=>this.btnmoadalindexreglement('FRS')},
                    {g:'out', titre:'Avance fournisseur',          detail:'Acompte versé à un fournisseur',   icone:'ri-user-shared-2-line',   ok:this.accessavancefournisseur, action:()=>this.btnmoadalindexavance('FRS')},
                    {g:'out', titre:'Retour de fonds de caisse',   detail:'Restituer le fonds de caisse',     icone:'ri-arrow-go-back-line',   ok:this.accesretourdefondsdecaisse, action:()=>this.btnmodaldepense('REF')},
                    {g:'out', titre:'Remboursement retours vente', detail:'Rembourser un client',             icone:'ri-refund-2-line',        ok:true, bientot:true},
                    {g:'out', titre:'Remboursement retours achat', detail:'Remboursement fournisseur',        icone:'ri-refund-line',          ok:true, bientot:true},
                    {g:'move',titre:A?'Transfert vers caisse principale':'Transfert vers caisse auxiliaire / principale', detail:'Envoyer des fonds', icone:'ri-exchange-funds-line', ok:this.accestransfertdefondscaisse, action:()=>this.btnmoadalindextransfertdefonddecaisse(A?'DPC':'APPROC',typc)},
                    {g:'move',titre:'Valider un transfert de fonds de caisse', detail:A?'Fonds reçus de la caisse principale':"Fonds reçus d'une caisse", icone:'ri-checkbox-circle-line', ok:true, action:()=>this.btnmoadalvalidationtransaction(A?'VAPPROC':'VDPC',typc)},
                    {g:'move',titre:'Valider un transfert de fonds de caisse principal', detail:'Fonds de caisse principal', icone:'ri-shield-check-line', ok:P, action:()=>this.btnmoadalvalidationtransaction('VAPPROC',typc)},
                    {g:'move',titre:'Opération bancaire',          detail:'Mouvement caisse / banque',        icone:'ri-bank-line',            ok:P&&this.accesoperationbancaire, action:()=>this.btnmoadalindextransfertdefonddecaisse('OPB',typc)},
                    {g:'move',titre:'Dépôts en banque',            detail:"Versement d'espèces en banque",    icone:'ri-bank-card-line',       ok:P&&this.acceslistedepotsenbanque, action:()=>this.btnmoadalindextransfertdefonddecaisse('DPB',typc)},
                    {g:'move',titre:'Approvisionnements caisse par la banque', detail:'Retrait banque vers caisse', icone:'ri-download-2-line', ok:P&&this.acceslistedesapprovisionnementscaissebanque, action:()=>this.btnmoadalindextransfertdefonddecaisse('APPRO',typc)},
                    {g:'move',titre:'Bordereaux de banque',        detail:'Enregistrer un bordereau',         icone:'ri-file-paper-2-line',    ok:this.accesenregistrerbordereauxdebanque, action:()=>this.btnmoadalindextransfertdefonddecaisse('BOR',typc)},
                    {g:'ctrl',titre:'État de paiement et billetage', detail:'Compter les billets, état du jour', icone:'ri-coins-line',       ok:true, action:()=>this.btnmodaletatdespaiement(P?'all':'unique')},
                    {g:'ctrl',titre:'État global des caisses fermées', detail:'Toutes les caisses clôturées', icone:'ri-stack-line',          ok:P, action:()=>this.btnmodaletatdespaiement('global')},
                    {g:'ctrl',titre:P?'Solde des caisses et banques':'Solde des banques', detail:'Vue consolidée des soldes', icone:'ri-scales-3-line', ok:this.accessoldecaissebanque, action:()=>this.btnmodalsoldecaissebanque(P?'ALL':'BANQUE')},
                    {g:'ctrl',titre:'Suivi de BCD interne à la caisse', detail:'Créer le suivi de BCD interne', icone:'ri-draft-line',        ok:P&&this.accescreationbcdinternecaisse, action:()=>this.btnmoadalindexbcd()},
                ];
                return ops.filter(o=>o.ok);
            },

            nboperationsdisponibles(){
                return this.operationscaisse.filter(o=>!o.bientot).length;
            },

            groupesoperations(){
                const q=(this.rechercheoperation||'').trim().toLowerCase();
                const liste=this.operationscaisse.filter(o=>!q || (o.titre+' '+o.detail).toLowerCase().includes(q));
                const groupes=[
                    {code:'in',   titre:'Encaissements',       icone:'ri-arrow-down-circle-line'},
                    {code:'out',  titre:'Décaissements',       icone:'ri-arrow-up-circle-line'},
                    {code:'move', titre:'Mouvements de fonds', icone:'ri-swap-box-line'},
                    {code:'ctrl', titre:'Contrôle et états',   icone:'ri-clipboard-line'},
                ];
                return groupes.map(g=>({...g, items:liste.filter(o=>o.g===g.code)})).filter(g=>g.items.length);
            },

            /* Couleurs fixes (recettes violet, dépenses rouge) à la place des couleurs aléatoires du serveur. */
            chartoptionscaisse(){
                const couleurs=(this.series4||[]).map(s=>s.name==='DEPENSE' ? '#E6533C' : '#845ADF');
                return {
                    ...this.chartOptions4,
                    colors: couleurs.length ? couleurs : ['#E6533C','#845ADF'],
                    chart: { type:'bar', height:350, toolbar:{ show:false }, fontFamily:'inherit' },
                    plotOptions: { bar: { horizontal:false, columnWidth:'55%', borderRadius:3 } },
                    grid: { borderColor:'#eef2f7', strokeDashArray:3 },
                    legend: { position:'top', horizontalAlign:'right' },
                    yaxis: { labels: { formatter: v => v>=1000 ? Math.round(v/1000)+' k' : v } },
                    tooltip: { y: { formatter: v => this.formatNumber(v)+' FCFA' } },
                };
            },

            top10courant(){
                return this.allgraphs[this.indextop10] || this.allgraphs[0] || null;
            },

            /* Le libellé serveur est « article ( montant ) » : on retire le montant, affiché à part. */
            top10lignes(){
                const g=this.top10courant;
                if (!g || !g.series || !g.chartOptions) return [];
                const max=Math.max(...g.series.map(Number), 1);
                return g.series.map((v,i)=>({
                    libelle:String((g.chartOptions.labels||[])[i]||'').replace(/\s*\([^()]*\)\s*$/,''),
                    montant:Number(v),
                    pct:Math.round(Number(v)/max*100),
                }));
            },

            comptesstock(){
                const base=this.filterdatatable;
                return {
                    tous:base.length,
                    faible:base.filter(a=>this.niveaustock(a.rstck)==='low').length,
                    rupture:base.filter(a=>this.niveaustock(a.rstck)==='ko').length,
                };
            },

            articlescaisse(){
                let m=this.filterdatatable;
                if (this.filtrestock==='faible') m=m.filter(a=>this.niveaustock(a.rstck)==='low');
                if (this.filtrestock==='rupture') m=m.filter(a=>this.niveaustock(a.rstck)==='ko');
                const k=this.tristock.cle, d=this.tristock.sens;
                return [...m].sort((a,b)=>k==='libelle'
                    ? String(a.libelle||'').localeCompare(String(b.libelle||''))*d
                    : (Number(a[k]||0)-Number(b[k]||0))*d);
            },


            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },

            filterdatatablestockminimum(){

                let mvalue=this.datatablestockminimum;

                mvalue = mvalue.filter( function (post) {
                    return   post.destination==="VENTE" ||
                        post.destination==="ACHAT_ET_VENTE"

                })

                return this.paginate(mvalue) ;

            },


            datatablearticle(){

                let mvalue=cloneobjet(this.listedesarticlespourlacaisse);

                mvalue = mvalue.filter( function (post) {
                    return   post.destination==="VENTE" ||
                        post.destination==="ACHAT_ET_VENTE"

                })

                return mvalue ;
            },

            filterdatatable(){



                let mvalue=cloneobjet(this.listedesarticlespourlacaisse);

                this.perPage=this.DefaultperPage;

                if (this.searchwordallprod!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {
                        return    post.libelle.toLowerCase().includes(t.searchwordallprod.toLowerCase())
                    })
                }

                //return mvalue ;
                return this.paginate(mvalue) ;
            },



            accesoperationbancaire(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="operationbancaire"){


                        mvalue=(macces.acces !== 0);
                    }

                });



                return mvalue
            },

            pagefacturationcaisse(){
                let mvalue=5;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="pagefacturationcaisse"){


                        mvalue=macces.acces;
                    }

                });


                return mvalue
            },


            accescreationbcdinternecaisse(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="creationbcdinternecaisse"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesenregistrerbordereauxdebanque(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="enregistrerbordereauxdebanque"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesreglementclt(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="reglementclt"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesreglementfrs(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="reglementfrs"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesreglementbcd(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="reglementbcd"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesdepotencompteclt(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="depotencompteclt"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesretourdefondsdecaisse(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="retourdefondsdecaisse"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },


            accestransfertdefondscaisse(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="transfertdefondscaisse"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },


            acceslistedepotsenbanque(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="listedepotsenbanque"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            acceslistedesapprovisionnementscaissebanque(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="listedesapprovisionnementscaissebanque"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesannulerfacture(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="annulerfacture"){


                        mvalue=(macces.acces !== 0);
                    }

                });
                return mvalue
            },

            accesfacturation(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="facturationcaisse"){


                        mvalue=(macces.acces !== 0);
                    }



                });



                return mvalue
            },

            accessoldecaissebanque(){
                let mvalue=false;


                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="voirsoldebanque"){


                        mvalue=(macces.acces !== 0);
                    }

                });

                return mvalue
            },

            accessavancefournisseur(){
                let mvalue=false;



                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="avancefournisseur"){


                        mvalue=(macces.acces !== 0);
                    }

                });

                return mvalue
            },


            accessavanceclient(){
                let mvalue=false;



                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="avanceclient"){


                        mvalue=(macces.acces !== 0);
                    }

                });

                return mvalue
            },


            accesdepense(){

                let mvalue=false;



                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="depensecaisse"){


                        mvalue=(macces.acces !== 0);
                    }



                });


                return mvalue
            },

            accestableauxdestock(){

                let mvalue=false;



                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="tableauxdestock"){


                        mvalue=(macces.acces !== 0);
                    }



                });


                return mvalue
            },


            accesmycaisse(){

                if (Object.keys(this.$store.state.caisseinfo).length>0)
                {
                    return true
                }else{
                    return false
                }
            },

             accesviewsoldecaisse(){

                let mvalue=false;

                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="viewsoldecaisse"){


                        mvalue=(macces.acces === 1);
                    }



                });

                return mvalue
            },
 

             accesviewrapporteditioncaisse(){

                let mvalue=false;

                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="viewrapporteditioncaisse"){


                        mvalue=(macces.acces === 1);
                    }



                });

                return mvalue
            },

             accesviewutilitairecaisse(){

                let mvalue=false;

                this.$store.state.niveauaccescaisse.forEach(function(macces) {

                    if (macces.name==="viewutilitairecaisse"){


                        mvalue=(macces.acces === 1);
                    }



                });

                return mvalue
            },




        },

        data() {
            return {
                /* Caisse type 6 : 'nouvelle' (form_index6_new, par défaut) ou 'ancienne'. */
                pos6Version: (function () { try { return localStorage.getItem('pos6_version_v1') === 'ancienne' ? 'ancienne' : 'nouvelle'; } catch (e) { return 'nouvelle'; } })(),
                pos6AncienneOuverte: false,
                searchword:"",
                searchwordallprod:"",
                datatablefindecontratpermannent:[],
                /* datatablearticle:[],*/
                datatabledocday:[],
                listedescaisses:[],
                datatablestockminimum:[],
                dateouverture:null,
                intitule:"",
                totaldepense:0,
                totalrecette:0,
                montantencaisse:0,

                /* Alerte « la journée de caisse ouverte n'est plus celle du jour ».
                   L'objet est calculé et journalisé par le SERVEUR à l'ouverture de
                   la caisse : le front ne compare aucune date, il se contente
                   d'afficher ce qu'il reçoit. */
                alertedatecaisse:null,
                showalertedatecaisse:false,

                /* Tableau de bord de la caisse (refonte 2026-10-25) */
                rechercheoperation:'',
                masquermontants:(function () { try { return localStorage.getItem('caisse_masquer_montants')==='1'; } catch (e) { return false; } })(),
                filtrestock:'tous',
                tristock:{ cle:'libelle', sens:1 },
                indextop10:0,



                allgraphs: [],

                series4: [],
                chartOptions4: {
                    colors:[],
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        title: {
                            text: 'FCFA'
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return "FCFA " + val + " "
                            }
                        }
                    }
                },






                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 500,
                Defaultpage: 1,
                DefaultperPage: 500,
                pages: [],

            };
        },
        methods: {

            /* ── Tableau de bord de la caisse (refonte 2026-10-25) ── */

            montantaffiche(v){
                return this.masquermontants ? '•••••••' : this.formatNumber(v);
            },

            basculermasquermontants(){
                this.masquermontants=!this.masquermontants;
                try { localStorage.setItem('caisse_masquer_montants', this.masquermontants ? '1' : '0'); } catch (e) { /* stockage indisponible */ }
            },

            /* Petite courbe du mois à partir de la série du graphique (DEPENSE / RECETTES). */
            tracersparkline(nom){
                const serie=(this.series4||[]).find(s=>s.name===nom);
                const data=serie ? (serie.data||[]).map(Number) : [];
                if (data.length<2) return '';
                const max=Math.max(...data), min=Math.min(...data), ecart=(max-min)||1;
                return 'M'+data.map((v,i)=>(i/(data.length-1)*200).toFixed(1)+','+(28-(v-min)/ecart*26).toFixed(1)).join(' L');
            },

            niveaustock(v){
                const n=Number(v||0);
                return n<=0 ? 'ko' : (n<10 ? 'low' : 'ok');
            },

            triercolonne(cle){
                if (this.tristock.cle===cle) this.tristock.sens*=-1;
                else this.tristock={ cle, sens:1 };
            },

            icone_tri(cle){
                if (this.tristock.cle!==cle) return 'ri-arrow-up-down-line';
                return this.tristock.sens>0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line';
            },

            ouvrircaissedepuismenu(){
                if (this.$refs.appmenu && this.$refs.appmenu.btnmoadalouverturecaisse) this.$refs.appmenu.btnmoadalouverturecaisse();
            },

            /* F2 : facturation ; « / » : recherche d'opération. Inactif si une modale est ouverte. */
            raccourcisclavier(e){
                if (this.pagefacturationcaisse===5 || this.pagefacturationcaisse===3) return;
                if (this.$store.state.ouverturedelacaisse===0) return;
                if (document.querySelector('.cf-overlay, .ti-modal.open, .hs-overlay.open')) return;
                const tag=(document.activeElement && document.activeElement.tagName)||'';
                if (e.key==='F2' && this.accesfacturation){ e.preventDefault(); this.btnfacturation(); }
                else if (e.key==='/' && tag!=='INPUT' && tag!=='TEXTAREA' && this.$refs.rechercheoperation){ e.preventDefault(); this.$refs.rechercheoperation.focus(); }
            },

            /* ── Caisse type 6 : ouverture de la version choisie sur ce poste ── */
            ouvrirPos6() {
                if (this.pos6Version === 'ancienne') {
                    this.pos6AncienneOuverte = true;
                    this.$refs.facturation6.show(this.datatablearticle);
                } else {
                    this.$refs.facturation6new.show(this.datatablearticle);
                }
            },

            /* Bascule ancienne / nouvelle. Refusée si un ticket est ouvert dans la
               version quittée (il n'est pas transféré). La fermeture de l'une ne
               doit pas déclencher le traitement de fin de facturation du parent. */
            changerVersionPos6(v) {
                const versNouvelle = v === 'nouvelle';
                const quittee = versNouvelle ? this.$refs.facturation6 : this.$refs.facturation6new;
                if (versNouvelle && quittee && ((quittee.listedatatable || []).length > 0 || (quittee.Items && quittee.Items.pidindexedb))) {
                    toastr['warning']("Mettez le ticket en attente ou terminez-le avant de changer de version.", '<b></b>');
                    return;
                }
                this.pos6Version = versNouvelle ? 'nouvelle' : 'ancienne';
                try { localStorage.setItem('pos6_version_v1', this.pos6Version); } catch (e) { /* stockage indisponible */ }
                const articles = this.datatablearticle;
                this._pos6Bascule = true;
                if (quittee) quittee.close();
                this._pos6Bascule = false;
                this.datatablearticle = articles;
                this.$nextTick(() => this.ouvrirPos6());
            },

            onClosedPos6(version, value) {
                if (version === 'ancienne') this.pos6AncienneOuverte = false;
                if (this._pos6Bascule) return;
                this.closemodalfacturation(value);
            },


            btnmodaletatdespaiement(value){


                let mname,numpidcaisse="",datedouverture=""



                if (value==='global'){
                    mname='Etat de paiement global des caisses';
                }else{
                    mname='Etat de paiement de la caisse';

                }

                if (this. $store.state.ouverturedelacaisse!==0){


                    if (Object.keys(this.$store.state.caisseinfo).length>0){

                        numpidcaisse=this.$store.state.caisseinfo.cpid,
                            datedouverture=this.$store.state.caisseinfo.dateouverture

                    }

                }
                else{


                    numpidcaisse=this.$store.state.caisseencour,
                        datedouverture=""


                }


                this.$refs.modaletatdespaiement.show(mname,numpidcaisse,datedouverture,value);

            },

            btnmoadalindexreglement(typedoc){


                let mname


                if (typedoc==='CLT'){

                    mname='Liste des factures clients partiellement réglées ou non réglées';
                }

                if (typedoc==='FRS'){

                    mname='Liste des factures fournisseurs partiellement réglées ou non réglées';
                }

                this.$refs.moadalindexreglement.show(mname,typedoc);

            },

            btnmoadalindextransfertdefonddecaisse(typedoc,vtypc){

                let mname

                this.$refs.moadalindextransfertdefonddecaisse.show(mname,typedoc,vtypc);

            },

            btnmodalsoldecaissebanque(value){


                let mname


                this.$refs.modalsoldecaissebanque.show(value);

            },

            btnmoadalvalidationtransaction(typedoc,vtypc){


                let mname


                this.$refs.moadalvalidationtransaction.show(mname,typedoc,vtypc);

            },

            btnfacturation(){
                let mname


                console.log("this.pagefacturationcaisse 11 ********* ",this.pagefacturationcaisse)

                if (this.pagefacturationcaisse===0 || this.pagefacturationcaisse==='0'){

                    this.$refs.facturation1.show(this.datatablearticle);

                }


                if (this.pagefacturationcaisse===1 || this.pagefacturationcaisse==='1'){

                    this.$refs.facturation2.show(this.datatablearticle);

                }

                if (this.pagefacturationcaisse===5 || this.pagefacturationcaisse==='5'){

                    this.$refs.facturation5.show(this.datatablearticle);

                }

                if (this.pagefacturationcaisse===6 || this.pagefacturationcaisse==='6'){

                    this.ouvrirPos6();

                }



            },

            btnmoadalindexbcd(){


                let mname

                mname="Création d'un BCD interne  pour le suivie";


                this.$refs.moadalindexbcd.show(mname);

            },

            btnmoadalindexreglementbcd(){

                let mname

                mname="Liste des BCD interne";

                this.$refs.moadalindexreglementbcd.show(mname);

            },

            btnmoadalindexavance(value){

                let mname

                if (value==="CLT"){   mname="Liste des avances clients";}
                if (value==="FRS"){   mname="Liste des avances fournisseurs";}



                this.$refs.moadalindexavance.show(mname,value);

            },

            btnmodaldepense(typedoc){


                let mname

                let  Item= {
                    pid:'',
                    docnum:'',
                    datedoc:this.$store.state.dateouverturecaisse,
                    docobservation:'',
                    beneficiaire:null,
                    document:this.typedoc,
                    mtnt:0,
                    alldepense:[],
                    params:{
                        param1:null,
                        param2:null,
                    },
                    jsondoc:{
                        key:''
                    },
                };

                if (typedoc==='DEP'){

                    mname='Liste des dépenses';
                }

                if (typedoc==='DPCC'){

                    mname='Liste des dépôts en compte client';
                }

                if (typedoc==='REF'){

                    mname='Liste des retours de fonds de caisse';
                }


                this.$refs.modaldepense.show(mname,typedoc);

            },



            formatNumber(num) {

                return  currencyFormatDE(num)
            },

            btnmoadalouverturecaisse(){


                let titlemodal="Ouverture de la caisse à la date du "+this.$tore.state.appserverdate

                let Item=value

                this.$refs.moadalouverturecaisse.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata);

            },

            btnopen(value){


                let titlemodal="Document "+value.numdoc

                let Item=value

                this.$refs.modalopenform.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata);

            },


            async inittableauarticle() {

                let $caisseencour=(Object.keys(this.$store.state.caisseinfo).length>0 && this.accestableauxdestock)?this.$store.state.caisseencour:"";
                if ($caisseencour===""){return }

                /*  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/egl745874pdefinition771714dfe/caisse/othetdskd8755dsdhisd/otherallproddksdk/'+$caisseencour+'/'+this.$store.state.appsociete+'/'+randomString();
                  let response =   axios  .get(url,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })

                   await response
                      .then(response => {

                          if (response.data.success){
                              t.datatablearticle=[]
                              t.datatablearticle=response.data.m

                          }
                          else{
                              t.datatablearticle=[]
                          }


                      })
                      .catch(

                          error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                              "<b></b>")
                      )
                      .finally(() =>  this.$store.dispatch('lancerchargement',false))

                  */

                this.$store.dispatch('loadlistedesarticlespourlacaisse',{pidcaisseencour:$caisseencour})
            },



            async loadtrt(){

                   let $caisseencour=(Object.keys(this.$store.state.caisseinfo).length>0 && this.accestableauxdestock)?this.$store.state.caisseencour:"";
                if ($caisseencour===""){return }
              

                //  console.log("$caisseencour ********* ",$caisseencour)

                this.$store.dispatch('resetloadlistedesarticlespourlacaisse',{pidcaisseencour:$caisseencour})
            },


            closemodalfacturation(value){

                this.datatablearticle=value
                this.loadsoldecaisse();

            },

            closemodal(){
                this.loadsoldecaisse();
                this.loadsuiviecaissegraph();
                this.loadtop10article();
            },

            async loadsoldecaisse() {


                let $caisseencour=(this.$store.state.caisseencour!=="" && this.$store.state.caisseencour!==null)?this.$store.state.caisseencour:"";
                if ($caisseencour===""){return }

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/caisse/fkdfkdozojdjsolde/'+this.$store.state.paramsystem.apikey+'/'+$caisseencour+'/'+this.$store.state.appsociete+'/895418init519151911515/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(response => {

                        if (response.data.success){

                            t.$store.dispatch('totaldepense',response.data.m.totaldepense);
                            t.$store.dispatch('totalrecette',response.data.m.totalrecette);
                            t.$store.dispatch('montantencaisse',response.data.m.solde);
                        }
                        else{

                            t.$store.dispatch('totaldepense',0);
                            t.$store.dispatch('totalrecette',0);
                            t.$store.dispatch('montantencaisse',0);
                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally()



            },

            async loadsuiviecaissegraph() {


                let $caisseencour=(this.$store.state.caisseencour!=="" && this.$store.state.caisseencour!==null)?this.$store.state.caisseencour:"";
                if ($caisseencour===""){return }

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/graph/gg/'+$caisseencour+'/'+this.$store.state.appsociete+'/8954graph18ss519151911515/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(response => {

                        if (response.data.success){

                            t.series4=response.data.xaxis;
                            t.chartOptions4.xaxis.categories=response.data.allgraphs
                            t.chartOptions4.colors=response.data.colors

                        }
                        else{

                            t.series4=[];
                            t.chartOptions4.xaxis.categories=[]

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally()



            },

            async loadtop10article() {


                let $caisseencour=(this.$store.state.caisseencour!=="" && this.$store.state.caisseencour!==null)?this.$store.state.caisseencour:"";
                if ($caisseencour===""){return }


                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/graph/gg/'+$caisseencour+'/'+this.$store.state.appsociete+'/8954toparticless519151911515/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                await response
                    .then(response => {


                        if (response.data.success){

                            t.allgraphs=response.data.allgraphs

                        }
                        else{


                            t.allgraphs=[]

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally()



            },

            init(){
                // this.inittableauarticle();
                this.loadsoldecaisse();
                this.loadsuiviecaissegraph();
                this.loadtop10article();

            },



            /**
             * Fermeture de la modale d'alerte de date de caisse.
             *
             * Croix et bouton « J'ai compris » appellent la même action. La modale se
             * ferme immédiatement - l'utilisateur n'a pas à attendre le réseau - et la
             * prise de connaissance part en arrière-plan. Le badge, lui, reste affiché
             * tant que la caisse est ouverte sur une journée antérieure.
             */
            fermeralertedatecaisse(){

                const t = this;

                t.showalertedatecaisse=false;

                if(t.alertedatecaisse===null || t.alertedatecaisse.pid===undefined){
                    return;
                }

                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/caisse/fkdfkdozojdj/'+this.$store.state.appsociete+'/895418alertedatecaisse519151911515/'+randomString();

                axios.post(url,{pid:t.alertedatecaisse.pid},{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true
                })
                .then(function (){
                    /* Rien à afficher : la trace est côté serveur. */
                })
                .catch(function (){
                    /* Silencieux à dessein : l'avertissement lui-même est déjà consigné
                       par le serveur, et rien ne justifie de bloquer le caissier ici. */
                })

            },

            async initcaisse(){

                this.$store.dispatch('lancerchargement',true)
                const t = this;

                t.dateouverture=null;
                t.intitule="";
                t.totaldepense=0;
                t.totalrecette=0;
                t.montantencaisse=0;
                var caisse={
                    'dateouverture':this.dateouverture,
                    'cc':this.$store.state.caisseencour,
                }



                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/caisse/fkdfkdozojdj/'+this.$store.state.appsociete+'/895418init519151911515/'+randomString();
                let response =   axios  .post(url,caisse,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })
                await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)

                        //  console.log("res.data ******* ",res.data)

                         if(res.data.dateserv!==undefined && res.data.dateserv!==null && res.data.dateserv!==''){

                                t.$store.commit('appserverdate',{name:res.data.dateserv})

                            }

                        if(res.data.success){


                            /* Alerte « journée de caisse antérieure au jour courant » : entièrement
                               calculée et déjà journalisée par le serveur. Sa seule présence dans la
                               réponse suffit - on n'effectue aucune comparaison de dates ici. */
                            if(res.data.alertedatecaisse!==undefined && res.data.alertedatecaisse!==null){

                                t.alertedatecaisse=res.data.alertedatecaisse;
                                t.showalertedatecaisse=true;

                            }else{

                                t.alertedatecaisse=null;
                                t.showalertedatecaisse=false;
                            }

                            t.$store.dispatch('dateouverturecaisse',res.data.m.dateouverture);
                            t.$store.dispatch('ouverturedelacaisse',1);
                            t.$store.dispatch('caisseinfo',res.data.m.caisseinfo);

                            t.$store.dispatch('niveauaccescaisse',res.data.m.vue.niveaudacces);
                            t.$store.dispatch('intitulecaisse',res.data.m.vue.intitule);
                            /*t.$store.dispatch('totaldepense',res.data.caisse.vue.totaldepense);
                            t.$store.dispatch('totalrecette',res.data.caisse.vue.totalrecette);
                            t.$store.dispatch('montantencaisse',res.data.caisse.vue.solde);*/
                            t.$store.dispatch('typc',res.data.m.vue.typc);

                            t.listedescaisses=res.data.m.listedescaisses

                            //t.allbk=res.data.caisse.allbk


                            /*
                               t.$refs.refmenucaisse.updatevariable(t.allbk,t.accessoldecaissebanque);

                            t.dateouverture=res.data.caisse.dateouverture;
                               t.intitule=res.data.caisse.vue.intitule;
                               t.totaldepense=res.data.caisse.vue.totaldepense;
                               t.totalrecette=res.data.caisse.vue.totalrecette;
                               t.montantencaisse=res.data.caisse.vue.solde;
                               t.typc=res.data.caisse.vue.typc;*/

                            t.inittableauarticle()

                        }
                        else{
                          

                            t.$store.dispatch('niveauaccescaisse',res.data.ac);
 
                            //t.$store.dispatch('beartoken',res.data.beartoken)
                            toastr['error']( res.data.message,"<b></b>");
                            // t.loading=false
                        }

                        
                           





                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>")
                    )
                    .finally(function () {
                        // t.$store.dispatch('lancerchargement',false)
                    })




            },



            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },

        provide() {

            return {

                reinitialiserAllarticle: this.loadtrt,
                loadsoldecaisse:     this.loadsoldecaisse,

            };
        },


        beforeUnmount() {
            document.removeEventListener('keydown', this.raccourcisclavier);
        },

        mounted() {

            document.addEventListener('keydown', this.raccourcisclavier);
 
            if(this.$store.state.caisseencour===''){

                toastr['error']( "Veuillez sélectionner une caisse valide.")


                this.$router.push({ name: 'tcaisse' });
            }
            else{
                this.initcaisse();

                this.init()
            }








        }






    }
</script>

<style scoped>
/* Bouton flottant : repasser de l'ancienne caisse type 6 à la nouvelle. */
.pos6-retour-nouvelle {
    position: fixed; left: 12px; bottom: 12px; z-index: 10001;
    display: inline-flex; align-items: center; gap: 6px;
    padding: 8px 14px; border-radius: 999px; border: 0;
    background: #2563eb; color: #fff; font-size: 13px; font-weight: 700;
    box-shadow: 0 6px 18px rgba(0,0,0,.25); cursor: pointer;
}
.pos6-retour-nouvelle:hover { background: #1d4ed8; }
@media (max-width: 640px) { .pos6-retour-nouvelle { bottom: 72px; } }


    .custom-box{
        padding: 10px;
    }

    .divmenuheader{
        margin-top: 60px;
    }
    .divmenuheader header{
        padding: 15px;
    }

    /* Charte cf-/ds- : enveloppe modale (light-only) — utilisée par l'alerte date caisse */
    .cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
    .cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
    .cf-dialog--md { max-width:600px; }
    .cf-dialog-body { padding:1.25rem 1.35rem; overflow-y:auto; flex:1; }
    .cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
    .cf-th { background:var(--cf-surface-alt)!important; color:var(--cf-ink)!important; font-weight:600; font-size:0.75rem; letter-spacing:0.02em; }

    .modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
    .modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
    .modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
    .modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    @media (max-width:768px) { .cf-dialog--md { max-width:100%; } }


    /* ----------------------------------------------------------------------
       Alerte « caisse ouverte à une date antérieure ».

       Le rouge est posé en dur plutôt que via les classes utilitaires : cette
       modale doit rester identiquement alarmante quel que soit le thème actif,
       clair comme sombre. Les tons sont ceux du danger du gabarit (#ef4444).
       ---------------------------------------------------------------------- */

    .alertedatecaisse-badge {
        cursor: pointer;
        color: #ffffff;
        background: #ef4444;
        border-radius: 0.35rem;
        padding: 0.35rem 0.6rem;
        font-size: 0.78rem;
        font-weight: 600;
        line-height: 1.1;
        white-space: nowrap;
        transition: background 0.15s ease-in-out;
    }

    .alertedatecaisse-badge:hover {
        background: #dc2626;
    }

    .alertedatecaisse-content {
        border: 0;
        overflow: hidden;
        box-shadow: 0 18px 45px rgba(239, 68, 68, 0.28);
    }

    .alertedatecaisse-bandeau {
        background: linear-gradient(90deg, #dc2626 0%, #ef4444 100%);
    }

    .alertedatecaisse-fermer {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.18);
        border: 0;
        flex: 0 0 auto;
        transition: background 0.15s ease-in-out;
    }

    .alertedatecaisse-fermer:hover {
        background: rgba(255, 255, 255, 0.34);
    }

    .alertedatecaisse-carte {
        border: 1px solid rgba(140, 144, 151, 0.25);
        border-radius: 0.4rem;
    }

    .alertedatecaisse-carte-danger {
        border: 1px solid rgba(239, 68, 68, 0.45);
        background: rgba(239, 68, 68, 0.07);
    }

    .alertedatecaisse-encart {
        border-inline-start: 4px solid #ef4444;
        border-radius: 0.35rem;
        background: rgba(239, 68, 68, 0.08);
    }

    /* Battement lent et discret : signale sans transformer la modale en gyrophare. */
    .alertedatecaisse-pulse {
        animation: alertedatecaissepulse 1.8s ease-in-out infinite;
    }

    @keyframes alertedatecaissepulse {
        0%, 100% { opacity: 1; }
        50%      { opacity: 0.45; }
    }

    /* Respect des préférences système : pas d'animation si l'utilisateur les refuse. */
    @media (prefers-reduced-motion: reduce) {
        .alertedatecaisse-pulse { animation: none; }
    }


    /* ======================================================================
       Tableau de bord de la caisse (refonte charte cf-/ds-, 2026-10-25).
       Préfixe cxe- ; tout est branché sur les tokens --cf-* et --primary.
       ====================================================================== */
    .cxe-page { padding: 1.25rem 1.4rem 2rem; background: #f3f4f8; min-height: calc(100vh - 120px); }
    .cxe-num { font-family: ui-monospace, "Cascadia Mono", Consolas, monospace; font-variant-numeric: tabular-nums; }
    .cxe-ink { color: var(--cf-ink); }
    .cxe-strong { font-weight: 600; }
    .cxe-btn { padding: 8px 13px; }

    /* En-tête */
    .cxe-head__title { display: flex; align-items: center; gap: 12px; }
    .cxe-head__icon { width: 46px; height: 46px; border-radius: 12px; background: rgb(var(--primary) / .1); color: rgb(var(--primary)); display: grid; place-items: center; font-size: 24px; flex: none; }
    .cxe-head__h1 { margin: 0; font-size: 1.3rem; font-weight: 800; color: var(--cf-ink-strong); letter-spacing: -.01em; }
    .cxe-head__sub { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin-top: 4px; font-size: .8rem; color: var(--cf-muted); }
    .cxe-head__actions { display: flex; gap: 8px; }
    .cxe-pill { display: inline-flex; align-items: center; gap: 5px; padding: 3px 10px; border-radius: 999px; font-size: .72rem; font-weight: 700; white-space: nowrap; }
    .cxe-pill--ok { background: rgb(var(--success) / .12); color: #0f8a68; }
    .cxe-pill--ok::before { content: ""; width: 7px; height: 7px; border-radius: 50%; background: rgb(var(--success)); animation: cxe-pulse 2s infinite; }
    .cxe-pill--off { background: var(--cf-surface-alt); color: var(--cf-muted); }
    .cxe-pill--off::before { content: ""; width: 7px; height: 7px; border-radius: 50%; background: var(--cf-faint); }
    .cxe-pill--type { background: rgb(var(--primary) / .1); color: rgb(var(--primary)); }
    .cxe-glow { animation: cxe-glow 2.2s infinite; }
    @keyframes cxe-pulse { 0%,100% { box-shadow: 0 0 0 3px rgb(var(--success) / .2); } 50% { box-shadow: 0 0 0 6px rgb(var(--success) / 0); } }
    @keyframes cxe-glow { 50% { box-shadow: 0 0 0 5px rgb(239 68 68 / .18); } }

    /* Bandeau : ticket de solde, KPI, facturation */
    .cxe-hero { display: grid; grid-template-columns: minmax(300px,1.15fr) 1fr 1fr minmax(240px,1fr); gap: 14px; margin-bottom: 22px; }
    .cxe-hero--nosolde { grid-template-columns: 1fr; }
    .cxe-ticket { position: relative; border-radius: 14px; padding: 18px 20px 22px; color: #e2e8f0; overflow: hidden;
        background: radial-gradient(120% 140% at 100% 0%, rgb(var(--primary) / .55) 0%, transparent 55%), linear-gradient(160deg, #1e1b3a 0%, #0f172a 100%);
        box-shadow: 0 14px 30px -14px rgb(76 50 160 / .55); }
    .cxe-ticket::after { content: ""; position: absolute; left: 0; right: 0; bottom: -1px; height: 10px;
        background: radial-gradient(circle at 7px 10px, #f3f4f8 6px, transparent 6.5px) 0 0 / 14px 10px repeat-x; }
    .cxe-ticket__lab { font-size: .68rem; text-transform: uppercase; letter-spacing: .12em; color: #a5b4fc; font-weight: 700; display: flex; align-items: center; justify-content: space-between; }
    .cxe-ticket__eye { border: 0; background: rgb(255 255 255 / .08); color: #c7d2fe; width: 28px; height: 28px; border-radius: 7px; cursor: pointer; }
    .cxe-ticket__eye:hover { background: rgb(255 255 255 / .16); }
    .cxe-ticket__amt { font-family: ui-monospace, "Cascadia Mono", Consolas, monospace; font-variant-numeric: tabular-nums; font-weight: 800; font-size: 2rem; color: #fff; letter-spacing: -.02em; margin: 8px 0 2px; white-space: nowrap; }
    .cxe-ticket__amt small { font-size: .85rem; color: #a5b4fc; font-weight: 700; margin-left: 6px; }
    .cxe-ticket__meta { font-size: .72rem; color: #94a3b8; }
    .cxe-ticket__meta b { font-family: ui-monospace, "Cascadia Mono", Consolas, monospace; }
    .cxe-ticket__flux { margin-top: 14px; height: 6px; border-radius: 99px; background: rgb(255 255 255 / .08); display: flex; overflow: hidden; }
    .cxe-ticket__flux span:first-child { background: rgb(var(--success)); }
    .cxe-ticket__flux span:last-child { background: rgb(var(--danger)); }
    .cxe-kpi { background: #fff; border: 1px solid var(--cf-border); border-radius: 14px; padding: 16px 18px; box-shadow: var(--cf-shadow-sm); display: flex; flex-direction: column; justify-content: space-between; min-width: 0; }
    .cxe-kpi__top { display: flex; align-items: center; justify-content: space-between; }
    .cxe-kpi__lab { font-size: .68rem; text-transform: uppercase; letter-spacing: .08em; color: var(--cf-muted); font-weight: 700; }
    .cxe-kpi__ic { width: 34px; height: 34px; border-radius: 10px; display: grid; place-items: center; font-size: 18px; }
    .cxe-kpi--in .cxe-kpi__ic { background: rgb(var(--success) / .12); color: rgb(var(--success)); }
    .cxe-kpi--out .cxe-kpi__ic { background: rgb(var(--danger) / .1); color: rgb(var(--danger)); }
    .cxe-kpi__v { font-family: ui-monospace, "Cascadia Mono", Consolas, monospace; font-variant-numeric: tabular-nums; font-weight: 800; font-size: 1.45rem; color: var(--cf-ink-strong); margin-top: 10px; white-space: nowrap; }
    .cxe-kpi__v small { font-size: .72rem; color: var(--cf-faint); margin-left: 4px; }
    .cxe-kpi__foot { font-size: .72rem; color: var(--cf-muted); margin-top: 6px; }
    .cxe-spark { display: block; width: 100%; height: 30px; margin-top: 6px; }
    .cxe-cta { border: 0; cursor: pointer; text-align: left; border-radius: 14px; padding: 18px 20px; color: #fff; position: relative; overflow: hidden;
        background: linear-gradient(135deg, rgb(var(--primary)) 0%, #6a3fd1 100%); box-shadow: 0 14px 26px -14px rgb(var(--primary) / .9); transition: transform .18s, box-shadow .18s; }
    .cxe-cta:hover { transform: translateY(-2px); box-shadow: 0 18px 30px -14px rgb(var(--primary)); }
    .cxe-hero--nosolde .cxe-cta { display: flex; align-items: center; gap: 16px; }
    .cxe-cta__ic { width: 44px; height: 44px; border-radius: 12px; background: rgb(255 255 255 / .18); display: grid; place-items: center; font-size: 24px; }
    .cxe-cta h3 { margin: 12px 0 2px; font-size: 1.15rem; font-weight: 800; color: #fff; }
    .cxe-hero--nosolde .cxe-cta h3 { margin-top: 0; }
    .cxe-cta p { margin: 0; font-size: .75rem; opacity: .85; }
    .cxe-cta kbd { position: absolute; top: 16px; right: 16px; font-family: ui-monospace, Consolas, monospace; font-size: .68rem; background: rgb(255 255 255 / .18); border-radius: 6px; padding: 3px 7px; }

    /* Opérations */
    .cxe-ops-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; margin-bottom: 12px; }
    .cxe-ops-head h2 { margin: 0; font-size: .95rem; font-weight: 800; color: var(--cf-ink-strong); }
    .cxe-ops-head h2 span { color: var(--cf-faint); font-weight: 600; font-size: .78rem; margin-left: 6px; }
    .cxe-search { position: relative; margin: 0; }
    .cxe-search > i { position: absolute; left: 11px; top: 50%; transform: translateY(-50%); color: var(--cf-faint); }
    .cxe-search input { height: 38px; width: 300px; max-width: 100%; border: 1px solid rgb(var(--input-border, 203 213 225)); border-radius: var(--cf-radius-sm); padding: 0 34px; font-size: .82rem; outline: none; background: #fff; color: var(--cf-ink); }
    .cxe-search input:focus { border-color: rgb(var(--primary)); box-shadow: 0 0 0 3px rgb(var(--primary) / .1); }
    .cxe-search kbd { position: absolute; right: 9px; top: 50%; transform: translateY(-50%); font-family: ui-monospace, Consolas, monospace; font-size: .65rem; color: var(--cf-faint); border: 1px solid var(--cf-border); border-radius: 4px; padding: 1px 5px; }
    .cxe-search--sm input { width: 200px; height: 34px; padding-right: 12px; }
    .cxe-groups { display: grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap: 14px; margin-bottom: 24px; align-items: start; }
    .cxe-grp { background: #fff; border: 1px solid var(--cf-border); border-radius: 14px; box-shadow: var(--cf-shadow-sm); overflow: hidden; }
    .cxe-grp__h { display: flex; align-items: center; gap: 9px; padding: 12px 14px; border-bottom: 1px solid var(--cf-surface-alt); }
    .cxe-grp__h b { font-size: .8rem; color: var(--cf-ink-strong); font-weight: 800; flex: 1; }
    .cxe-grp__dot { width: 28px; height: 28px; border-radius: 8px; display: grid; place-items: center; font-size: 15px; }
    .cxe-grp__n { font-size: .68rem; font-weight: 700; color: var(--cf-faint); background: var(--cf-surface-alt); border-radius: 99px; padding: 1px 8px; }
    .cxe-g-in .cxe-grp__dot { background: rgb(var(--success) / .12); color: rgb(var(--success)); }
    .cxe-g-out .cxe-grp__dot { background: rgb(var(--danger) / .1); color: rgb(var(--danger)); }
    .cxe-g-move .cxe-grp__dot { background: rgb(var(--info) / .14); color: #1c8fd1; }
    .cxe-g-ctrl .cxe-grp__dot { background: rgb(var(--warning) / .18); color: #b7791f; }
    .cxe-op { display: flex; align-items: center; gap: 11px; width: 100%; border: 0; border-left: 3px solid transparent; background: transparent; text-align: left; padding: 9px 14px; cursor: pointer; transition: background .15s; }
    .cxe-op:hover { background: var(--cf-surface); border-left-color: rgb(var(--primary)); }
    .cxe-op__i { width: 32px; height: 32px; flex: none; border-radius: 9px; background: var(--cf-surface-alt); color: var(--cf-muted); display: grid; place-items: center; font-size: 16px; transition: .15s; }
    .cxe-op:hover .cxe-op__i { background: rgb(var(--primary) / .1); color: rgb(var(--primary)); }
    .cxe-op__t { flex: 1; min-width: 0; }
    .cxe-op__t b { display: block; font-size: .8rem; font-weight: 700; color: var(--cf-ink); }
    .cxe-op__t span { display: block; font-size: .68rem; color: var(--cf-faint); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cxe-op__go { color: rgb(var(--primary)); opacity: 0; transform: translateX(-4px); transition: .15s; }
    .cxe-op:hover .cxe-op__go { opacity: 1; transform: none; }
    .cxe-op--soon { cursor: not-allowed; opacity: .6; }
    .cxe-op--soon:hover { background: transparent; border-left-color: transparent; }
    .cxe-op--soon:hover .cxe-op__i { background: var(--cf-surface-alt); color: var(--cf-muted); }
    .cxe-soon { font-size: .62rem; font-weight: 700; color: #b7791f; background: rgb(var(--warning) / .18); border-radius: 99px; padding: 1px 7px; white-space: nowrap; }
    .cxe-empty { grid-column: 1 / -1; display: flex; flex-direction: column; align-items: center; gap: 6px; text-align: center; padding: 30px; color: var(--cf-muted); background: #fff; border: 1px dashed var(--cf-border); border-radius: 14px; }
    .cxe-empty i { font-size: 26px; color: var(--cf-faint); }
    .cxe-empty--flat { border: 0; border-radius: 0; }

    /* Analyse */
    .cxe-ana { display: grid; grid-template-columns: 1.35fr 1fr; gap: 14px; margin-bottom: 14px; }
    .cxe-card { background: #fff; border: 1px solid var(--cf-border); border-radius: 14px; box-shadow: var(--cf-shadow-sm); min-width: 0; }
    .cxe-card__h { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 13px 16px; border-bottom: 1px solid var(--cf-surface-alt); flex-wrap: wrap; }
    .cxe-card__h h3 { margin: 0; font-size: .85rem; font-weight: 800; color: var(--cf-ink-strong); display: flex; align-items: center; gap: 8px; }
    .cxe-card__h h3 i { color: rgb(var(--primary)); }
    .cxe-card__sub { font-weight: 600; color: var(--cf-faint); font-size: .75rem; }
    .cxe-card__b { padding: 14px 16px; }
    .cxe-card__tools { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
    .cxe-tabs { display: inline-flex; background: var(--cf-surface-alt); border-radius: 8px; padding: 3px; flex-wrap: wrap; }
    .cxe-tabs button { border: 0; background: transparent; font-size: .72rem; font-weight: 700; color: var(--cf-muted); padding: 5px 10px; border-radius: 6px; cursor: pointer; }
    .cxe-tabs button.on { background: #fff; color: rgb(var(--primary)); box-shadow: var(--cf-shadow-sm); }
    .cxe-top10 { list-style: none; margin: 0; padding: 0; }
    .cxe-top10 li { display: grid; grid-template-columns: 22px 1fr auto; gap: 10px; align-items: center; padding: 6px 0; font-size: .8rem; }
    .cxe-top10__rk { font-family: ui-monospace, Consolas, monospace; font-size: .7rem; color: var(--cf-faint); font-weight: 700; }
    .cxe-top10__lib { font-weight: 600; color: var(--cf-ink); }
    .cxe-top10__bar { height: 6px; border-radius: 99px; background: var(--cf-surface-alt); margin-top: 5px; overflow: hidden; }
    .cxe-top10__bar span { display: block; height: 100%; border-radius: 99px; background: rgb(var(--primary)); transition: width .5s ease-out; }
    .cxe-top10 li:nth-child(n+4) .cxe-top10__bar span { background: rgb(var(--primary) / .45); }
    .cxe-top10__q { font-family: ui-monospace, "Cascadia Mono", Consolas, monospace; font-weight: 700; font-size: .78rem; color: var(--cf-ink-strong); text-align: right; white-space: nowrap; }
    .cxe-top10__q small { font-size: .65rem; color: var(--cf-faint); font-weight: 500; margin-left: 3px; }

    /* Table des articles */
    .cxe-chips { display: flex; gap: 6px; flex-wrap: wrap; }
    .cxe-chip { border: 1px solid var(--cf-border); background: #fff; border-radius: 99px; font-size: .72rem; font-weight: 700; color: var(--cf-muted); padding: 4px 10px; cursor: pointer; }
    .cxe-chip b { font-family: ui-monospace, Consolas, monospace; margin-left: 4px; }
    .cxe-chip.on { background: rgb(var(--primary) / .1); border-color: rgb(var(--primary) / .35); color: rgb(var(--primary)); }
    .cxe-tbl-wrap { max-height: 380px; overflow: auto; }
    .cxe-table { width: 100%; border-collapse: collapse; font-size: 13px; }
    .cxe-table .th { position: sticky; top: 0; z-index: 2; padding: .65rem 1rem; font-weight: 700; font-size: .72rem; color: var(--cf-ink); background: var(--cf-surface-alt); border-bottom: 1px solid var(--cf-border); white-space: nowrap; text-align: left; }
    .cxe-table .th--r, .cxe-table .td--r { text-align: right; }
    .cxe-th-sort { cursor: pointer; user-select: none; }
    .cxe-th-sort i { color: var(--cf-faint); font-size: 13px; vertical-align: -2px; }
    .cxe-th-sort.on i { color: rgb(var(--primary)); }
    .cxe-table .td { padding: .6rem 1rem; font-size: .82rem; color: var(--cf-ink); border-bottom: 1px solid var(--cf-surface-alt); white-space: nowrap; }
    .cxe-table tbody tr:hover { background: var(--cf-surface); }
    .cxe-st { display: inline-flex; align-items: center; gap: 4px; font-family: ui-monospace, Consolas, monospace; font-weight: 700; font-size: .75rem; padding: 2px 8px; border-radius: 99px; }
    .cxe-st--ok { background: #dcfce7; color: #15803d; }
    .cxe-st--low { background: #fef3c7; color: #b45309; }
    .cxe-st--ko { background: #fee2e2; color: #b91c1c; }
    .cxe-tbl-foot { display: flex; justify-content: space-between; gap: 10px; padding: 10px 16px; font-size: .75rem; color: var(--cf-muted); border-top: 1px solid var(--cf-surface-alt); }

    /* Caisse fermée */
    .cxe-closed { display: grid; grid-template-columns: 1.2fr 1fr; gap: 14px; align-items: start; }
    .cxe-closed__hero { border-radius: 16px; padding: 28px; background: #fff; border: 1px solid var(--cf-border); position: relative; overflow: hidden; box-shadow: var(--cf-shadow-sm); }
    .cxe-closed__hero::before { content: ""; position: absolute; inset: 0; background: repeating-linear-gradient(-45deg, transparent 0 14px, rgb(var(--primary) / .035) 14px 28px); }
    .cxe-closed__hero > * { position: relative; }
    .cxe-closed__ic { width: 64px; height: 64px; border-radius: 18px; background: rgb(var(--primary) / .1); color: rgb(var(--primary)); display: grid; place-items: center; font-size: 32px; }
    .cxe-closed__hero h2 { font-size: 1.35rem; font-weight: 800; margin: 16px 0 6px; color: var(--cf-ink-strong); }
    .cxe-closed__hero p { margin: 0 0 20px; color: var(--cf-muted); max-width: 460px; }
    .cxe-btn-open { display: inline-flex; align-items: center; gap: 6px; }

    @media (max-width: 1280px) { .cxe-hero { grid-template-columns: 1fr 1fr; } .cxe-groups { grid-template-columns: repeat(2, minmax(0,1fr)); } }
    @media (max-width: 1024px) { .cxe-ana, .cxe-closed { grid-template-columns: 1fr; } }
    @media (max-width: 640px) {
        .cxe-page { padding: 1rem; }
        .cxe-hero, .cxe-groups { grid-template-columns: 1fr; }
        .cxe-cta { order: -1; }
        .cxe-ticket__amt { font-size: 1.7rem; }
        .cxe-search, .cxe-search input { width: 100%; }
        .cxe-ops-head .cxe-search { flex: 1 1 100%; }
        .cxe-table .td, .cxe-table .th { padding: .55rem .6rem; }
    }
    @media (prefers-reduced-motion: reduce) { .cxe-pill--ok::before, .cxe-glow { animation: none; } }

</style>